import { render, staticRenderFns } from "./createKFMessage.vue?vue&type=template&id=ba1999fa&scoped=true&"
import script from "./createKFMessage.vue?vue&type=script&lang=js&"
export * from "./createKFMessage.vue?vue&type=script&lang=js&"
import style0 from "./createKFMessage.vue?vue&type=style&index=0&id=ba1999fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1999fa",
  null
  
)

export default component.exports